import { Categories } from '@/types/session.types';
import { Get } from '../helpers';

export const FetchCategories = async (channel: number): Promise<Categories[]> => {
  return Get({
    path: `/v3/admin/events/tracks/${channel}`,
  });
};
